import { Navigate, useLocation, useParams, useSearchParams } from 'react-router';

import { PERSONAL_CENTER_PANELS, ROUTES } from '#/config/routes';

/**
 * 舊 /account/profile?panel=… → 新 hub（保留合法 panel）。
 */
export function RedirectLegacyAccountProfile() {
  const [searchParams] = useSearchParams();
  const raw = searchParams.get('panel');
  const panel = PERSONAL_CENTER_PANELS.includes(raw) ? raw : 'profile';
  return <Navigate to={ROUTES.personalCenterPanel(panel)} replace />;
}

/**
 * 舊 /account/edit → 新 edit（保留 ?tab= 等 query）。
 */
export function RedirectLegacyAccountEdit() {
  const location = useLocation();
  return (
    <Navigate
      to={{
        pathname: ROUTES.personalCenterEdit,
        search: location.search,
      }}
      replace
    />
  );
}

export function RedirectLegacyVoucherEdit() {
  const { id } = useParams();
  return <Navigate to={ROUTES.personalCenterVoucherEdit(id)} replace />;
}

export function RedirectLegacyClaimEdit() {
  const { id } = useParams();
  return <Navigate to={ROUTES.personalCenterClaimEdit(id)} replace />;
}
